<template>
    <div
        class="navigation-buttons px-2"
        :class="[isButtonBack ? 'ion-justify-content-between' : 'ion-justify-content-end']"
    >
        <div class="max-size p-relative">
            <button-base
                v-if="isButtonBack"
                class="round-button no-shadow circle-button back-navigation"
                :color="ION_VARIANT.GREY_4"
                @click="$emit('back')"
            >
                <ion-icon :icon="chevronBack" class="grey1-grey1-color"/>
            </button-base>
            <button-base
                v-if="isButtonForward"
                class="round-button no-shadow circle-button forward-navigation"
                :color="ION_VARIANT.GREY_4"
                @click="$emit('foward')"
            >
                <ion-icon slot="icon-only" :icon="chevronForward" class="grey1-grey1-color"/>
            </button-base>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { IonIcon } from "@ionic/vue";

import ButtonBase from "./ButtonBase.vue";

import { ION_VARIANT } from '@/types/enum/ionicEnum';

import { chevronBack, chevronForward } from "ionicons/icons";

defineProps<{ isButtonBack?: boolean, isButtonForward?: boolean }>()
defineEmits<{ (e: 'back'): void, (e: 'foward'): void }>()
</script>

<style>
.navigation-buttons {
    width: 100%;
    top: calc(50% - 25px);
    display: flex;
    position: absolute;
}

.navigation-buttons .base-button {
    position: absolute;
    top: 0;
    z-index: 2;
}

.circle-button {
    width: 50px;
    height: 50px;
}

.back-navigation {
    left: 0;
}

.forward-navigation {
    right: 0;
}
</style>
